import { routes } from '#pplx/frontend/apps/ask/routing/spaRoutes.js';
export const ENTERPRISE_ONBOARDING_URL = '/onboarding/org/create';
export const ENTERPRISE_ONBOARDING_RETURN_TO_PARAM = 'return_to';
export const ENTERPRISE_PROMOTION_CODE_PARAM = 'promotion_code';
export const ENTERPRISE_SUCCESS_REDIRECT_PARAM = 'success_redirect';
export const ENTERPRISE_UPSELL_MODAL_PARAM = 'enterprise-upsell';
// Marks the post-org-deletion landing; read by useOrgDeletedUpsellHandler to
// offer the consumer paywall when no individual subscription remains.
export const ORG_DELETED_PARAM = 'org-deleted';
export const ONBOARDING_INITIAL_STEP_PARAM_NAME = 'initialStep';
const ENTERPRISE_ONBOARDING_PATH_BY_RETURN_TO = {
    home: '/',
    settings: '/account',
    onboarding: '/onboarding?plan=business',
    pricing: `/?${ENTERPRISE_UPSELL_MODAL_PARAM}=business`,
};
export const getEnterpriseOnboardingURL = (returnTo) => {
    if (!returnTo) {
        return ENTERPRISE_ONBOARDING_URL;
    }
    const params = new URLSearchParams({
        [ENTERPRISE_ONBOARDING_RETURN_TO_PARAM]: returnTo,
    });
    return `${ENTERPRISE_ONBOARDING_URL}?${params.toString()}`;
};
export const ENTERPRISE_ONBOARDING_HOME_URL = getEnterpriseOnboardingURL('home');
export const ENTERPRISE_ONBOARDING_SETTINGS_URL = getEnterpriseOnboardingURL('settings');
export const getEnterpriseOnboardingBackPathForReturnTo = (returnTo) => {
    if (!returnTo)
        return undefined;
    return ENTERPRISE_ONBOARDING_PATH_BY_RETURN_TO[returnTo];
};
export const getEnterpriseOnboardingReturnTo = (searchParams) => {
    const returnTo = searchParams?.get(ENTERPRISE_ONBOARDING_RETURN_TO_PARAM);
    if (returnTo && returnTo in ENTERPRISE_ONBOARDING_PATH_BY_RETURN_TO) {
        return returnTo;
    }
    return undefined;
};
const SUCCESS_REDIRECT_NORMALIZATION_BASE = 'https://www.perplexity.ai';
const DEFAULT_SUCCESS_REDIRECT = routes['/'].href();
// Post-payment destinations we support. Query strings and fragments are kept, so
// `/computer/new?sub_segment=research` is allowed via the `/computer/new` entry.
const ALLOWED_SUCCESS_REDIRECT_PATHNAMES = new Set([
    routes['/'].href(),
    routes['/computer/new'].href(),
]);
export const getEnterpriseSuccessRedirect = (searchParams) => {
    const redirect = searchParams?.get(ENTERPRISE_SUCCESS_REDIRECT_PARAM);
    if (!redirect?.startsWith('/') ||
        redirect.startsWith('//') ||
        redirect.includes('\\') ||
        // Reject ASCII control characters and spaces (0x00-0x20) plus DEL (0x7f).
        // URL parsing silently strips tabs/newlines, so `/\n/evil.example` would
        // otherwise collapse into the protocol-relative `//evil.example`.
        Array.from(redirect).some((character) => {
            const code = character.charCodeAt(0);
            return code <= 0x20 || code === 0x7f;
        })) {
        return DEFAULT_SUCCESS_REDIRECT;
    }
    // Resolve dot segments (literal or percent-encoded) before checking the
    // allowlist so `/x/../computer/new` matches and `/x/..//evil.example` cannot.
    const normalized = new URL(redirect, SUCCESS_REDIRECT_NORMALIZATION_BASE);
    if (normalized.origin !== SUCCESS_REDIRECT_NORMALIZATION_BASE ||
        !ALLOWED_SUCCESS_REDIRECT_PATHNAMES.has(normalized.pathname)) {
        return DEFAULT_SUCCESS_REDIRECT;
    }
    return `${normalized.pathname}${normalized.search}${normalized.hash}`;
};
export const getEnterpriseCheckoutURL = ({ subscriptionTier, orgDraftUuid, plan, backPath, onboardingReturnTo, sourceSearchParams, }) => {
    const checkoutParams = new URLSearchParams({
        subscriptionTier,
        orgDraftUuid,
        plan,
    });
    if (backPath) {
        checkoutParams.set('backPath', backPath);
    }
    if (onboardingReturnTo) {
        checkoutParams.set(ENTERPRISE_ONBOARDING_RETURN_TO_PARAM, onboardingReturnTo);
    }
    const promotionCode = sourceSearchParams?.get(ENTERPRISE_PROMOTION_CODE_PARAM);
    if (promotionCode) {
        checkoutParams.set(ENTERPRISE_PROMOTION_CODE_PARAM, promotionCode);
    }
    if (sourceSearchParams?.has(ENTERPRISE_SUCCESS_REDIRECT_PARAM)) {
        checkoutParams.set(ENTERPRISE_SUCCESS_REDIRECT_PARAM, getEnterpriseSuccessRedirect(sourceSearchParams));
    }
    return `/checkout/enterprise?${checkoutParams.toString()}`;
};
//# sourceMappingURL=enterpriseOnboarding.js.map